import enquireJs from 'enquire.js'
import {Modal} from "ant-design-vue";
import Vue from 'vue';


export function isDef(v) {
	return v !== undefined && v !== null
}

/**
 * Remove an item from an array.
 */
export function remove(arr, item) {
	if (arr.length) {
		const index = arr.indexOf(item)
		if (index > -1) {
			return arr.splice(index, 1)
		}
	}
}

export function isRegExp(v) {
	return _toString.call(v) === '[object RegExp]'
}

export function enquireScreen(call) {
	const handler = {
		match: function () {
			call && call(true)
		},
		unmatch: function () {
			call && call(false)
		}
	}
	enquireJs.register('only screen and (max-width: 767.99px)', handler)
}

const _toString = Object.prototype.toString


/**
 * 显示遮罩，直到主动关闭
 * @param message
 * @param title
 * @returns {{visible: boolean, text: (*|string), title: (*|null), close: function}|Vue}
 */
export function showMask(message, title = null) {
	const modal = new Vue({
		template: `
      <a-modal
          centered
          :title="title"
          :visible="visible"
          :footer="null"
          :closable="false"
          :keyboard="false"
          :maskClosable="false"
          :destroyOnClose="true"
      >
      {{ text }}
      </a-modal>
		`,
		components: {
			Modal
		},
		data() {
			return {
				title: title || null,
				visible: true,
				text: message || "正在执行，请稍候..."
			}
		},
		methods: {
			close() {
				this.visible = false;
			}
		}
	}).$mount();
	return modal;
}


export function validatorPhone(rule, value, callback) {
	if (!value) {
		callback(new Error('手机号不能为空'))
	} else if (!/^1\d{10}$/.test(value)) {
		callback(new Error('手机号格式错误'))
	} else {
		callback()
	}
}

export function validatorPhoneNoRequire(rule, value, callback) {
	if (!value) {
		callback()
	} else if (!/^1\d{10}$/.test(value)) {
		callback(new Error('手机号格式错误'))
	} else {
		callback()
	}
}

export function validatorEmail(rule, value, callback) {
	if (!value) {
		callback(new Error('邮箱不能为空'))
	} else if (!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
		callback(new Error('邮箱格式错误'))
	} else {
		callback()
	}
}

/**
 * 邮箱验证 含空
 * @param rule
 * @param value
 * @param callback
 */
export function validatorEmailNoRequire(rule, value, callback) {
	if (!value) {
		callback()
	} else if (!/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
		callback(new Error('邮箱格式错误'))
	} else {
		callback()
	}
}

/**
 * 打印
 * @param html 内部节点数据
 * 纸张大小换算
 */
export function jsPrint(html) {
	let iframe = document.createElement('iframe');
	iframe.style.width = '0';
	iframe.style.height = '0';
	iframe.style.border = "none";
	document.getElementsByTagName('body')[0].appendChild(iframe);
	setTimeout(() => {
		iframe.contentDocument.write(html);
		iframe.contentDocument.close();
		iframe.contentWindow.focus();
		iframe.contentWindow.print();
		iframe.remove();
	}, 100)
}

